import React from 'react';
import dayjs from 'dayjs';
import { DateItemWrapper } from './CandidateScheduleDateSelector.styles';

const SelectableDateItem = ({ date, onClick }) => {
  const handleClick = () => {
    onClick(date.id);
  };

  return (
    <DateItemWrapper backgroundColor="rgb(255, 255, 255)" isClickable={true} onClick={handleClick}>
      <div className="date-content">
        <div className="date-info">
          <div className="date-display">
            <div className="mobile_display">{dayjs(date.DateOfInterview).format('ddd, MMM DD, YYYY')}</div>
            <div className="browser_display">{dayjs(date.DateOfInterview).format('ddd, MMMM DD, YYYY')}</div>
          </div>
          {date.Label && <div className="date-label">{date.Label}</div>}
        </div>
      </div>
    </DateItemWrapper>
  );
};

export default SelectableDateItem;
